import React, { useState } from "react";
import "../../Styles/Tags/SelectTag.css";
import searchIcon from "../../Assets/SearchIcon.svg";
import { IoIosAddCircleOutline } from "react-icons/io";
import { addTag, reomveTag } from "../../Redux/Reducer/FormSlices";
import tagCloseIcon from "../../Assets/tagCloseIcon.png";
import { useDispatch } from "react-redux";
import closeIcon from "../../Assets/propertiesCloseIcon.svg";
import * as FaIcons from "react-icons/fa";
import ReactModal from "react-modal";

export const SelectTag = ({ isOpen, onClose, tags, onCreateTag, allTags }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const filteredTags = allTags.filter((tag) =>
    tag.tagName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  if (!isOpen) return null;

  //Tag color get for background
  function hexToRGBA(hex, opacity) {
    // Remove the "#" if present
    hex = hex.replace("#", "");

    // Parse the r, g, b values from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Return the rgba string with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  const handelRemoveTag = (tagIndex) => {
    dispatch(reomveTag({ tagIndex }));
  };

  const handleAddTag = (selectedTag) => {
    dispatch(addTag({ selectedTag }));
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      height: "60%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  return (
    // <div className="selectTagmodal-overlay" onClick={onClose}>
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="selectTagmodal-content">
        <div className="model_closeicon">
          <img src={closeIcon} alt="close-btn" onClick={onClose} />
        </div>
        <div className="tag_select_input_container">
          <img src={searchIcon} alt="searchIcon" />
          <input
            type="text"
            placeholder="Search in tags"
            className="tagSelect_input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="selected_tag">
          {tags.map((tag, index) => (
            <div
              style={{
                color: tag.tagColor,
                backgroundColor: hexToRGBA(tag.tagColor, 0.1),
              }}
              className="tagText"
            >
              {tag.tagIcon && (
                <div style={{ textAlign: "center" }}>
                  {React.createElement(FaIcons[tag.tagIcon], {
                    size: 30,
                    style: { color: tag.tagColor, padding: "6px" },
                  })}
                </div>
              )}
              {tag.tagName}
              <img
                src={tagCloseIcon}
                alt="close"
                onClick={() => handelRemoveTag(index)}
              />
            </div>
          ))}
        </div>

        <hr />
        {/* <Tags tag={tags} /> */}
        <div className="allTags_container">
          {filteredTags.map((tag, index) => {
            const isSelected = tags.some(
              (selectedTag) => selectedTag.tagName === tag.tagName
            );
            return (
              <div
                style={{
                  color: tag.tagColor,
                  backgroundColor: hexToRGBA(tag.tagColor, 0.1),
                }}
                className="tagText"
                onClick={() => !isSelected && handleAddTag(tag)}
              >
                {tag.tagIcon && (
                  <div style={{ textAlign: "center" }}>
                    {React.createElement(FaIcons[tag.tagIcon], {
                      size: 30,
                      style: { color: tag.tagColor, padding: "5px" },
                    })}
                  </div>
                )}
                {tag.tagName}
              </div>
            );
          })}
        </div>
        <div className="add_teg_btn tagText" onClick={onCreateTag}>
          <IoIosAddCircleOutline
            style={{ fontSize: "16px", color: "#8493B2" }}
          />
          Create Tag
        </div>
      </div>
    </ReactModal>
    // </div>
  );
};
